var _style, _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.3,25.4C333.6,9.1,295.9,0,256,0s-77.6,9.1-111.3,25.4L122.4,256l22.3,230.6C178.4,502.9,216.1,512,256,512 s77.6-9.1,111.3-25.4L389.6,256L367.3,25.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.7,25.4C59.1,66.8,0,154.5,0,256s59.1,189.2,144.7,230.6V25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.3,25.4v461.2C452.9,445.2,512,357.5,512,256S452.9,66.8,367.3,25.4L367.3,25.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M333.9,155.8l14.9,7.5L333.9,155.8l-14.9-7.5c-0.9,1.8-20.4,41.5-23.6,102.1h-22.7v-94.6L256,133.6l-16.7,22.3v94.6h-22.7 c-3.2-60.6-22.7-100.3-23.6-102.1l-29.9,14.9c0.2,0.4,20.5,41.7,20.5,103.8v16.7h55.7v94.6h33.4v-94.6h55.7v-16.7 c0-32.1,5.6-58.6,10.2-75.2c5.1-18.1,10.2-28.6,10.3-28.7L333.9,155.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/bb.0c288265ad46eaa9775fd8e07267439e.svg";
export { ForwardRef as ReactComponent };